import React from 'react';

const SummarySection = () => {
  // Certification data
  const certifications = [
    {
      src: "/certified-safe-6-product-owner-product-manager.webp",
      alt: "SAFe Product Owner/Product Manager",
      url: "https://www.credly.com/badges/aa692851-7db3-412d-9ac3-d9b1e32d785f/print"
    },
    {
      src: "/scrum-alliance-cspo-600.webp",
      alt: "Certified Scrum Product Owner",
      url: "https://bcert.me/bc/html/show-badge.html?b%3Dfvtrubyc"
    },
    {
      src: "/Certiprof_Scrum_Master_badge480x480_1440x1440.webp",
      alt: "CertiProf Scrum Master",
      url: "https://drive.google.com/drive/folders/16d43UZRVDwz6l8k1jxgnFUWq2p28YVV3"
    },
    {
      src: "/EF-SET-C2-Proficient.webp",
      alt: "EF SET C2 Proficient English",
      url: "https://cert.efset.org/A5YhqH"
    }
  ];

  return (
    <section className="bg-white text-apple-gray-800 py-20 px-4" id="summary">
      <div className="max-w-4xl mx-auto">
        {/* 3-row layout */}
        <div className="space-y-12">

          {/* Row 1 - Profile Picture and Elemento 43 Logo */}
          <div className="flex flex-col md:flex-row justify-center items-center gap-8 md:gap-16">
            {/* Profile Picture */}
            <div className="flex justify-center">
              <img
                loading="lazy"
                decoding="async"
                src="/ProfilePictureCCardenoC-Completa 202406 Small.webp"
                alt="Charly Cardeno"
                className="w-48 h-48 rounded-full object-cover shadow-lg"
              />
            </div>

            {/* Elemento 43 Logo */}
            <div className="flex justify-center">
              <a
                href="https://elemento43.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="block hover:opacity-80 transition-opacity duration-200"
              >
                <img
                  loading="lazy"
                  decoding="async"
                  src="/elemento43.webp"
                  alt="Elemento 43 Logo"
                  className="w-48 h-48 rounded-full object-cover shadow-lg"
                />
              </a>
            </div>
          </div>

          {/* Row 2 - Paragraph Content */}
          <div className="text-center px-4 space-y-6">
            <p className="text-apple-gray-700 text-lg leading-relaxed max-w-3xl mx-auto">
              Helping non-technical founders take back control of their product, own their vision, and stop feeling at the mercy of their dev team.
              You'll have someone in your corner making sure the work gets done right.
            </p>
            <p className="text-apple-gray-700 text-lg leading-relaxed max-w-3xl mx-auto">
              With 5 years running my own software agency, <a
                href="https://elemento43.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="font-bold text-apple-gray-800 hover:text-blue-600 transition-colors duration-200"
              >
                Elemento 43
              </a>, I know exactly where things go wrong when working with offshore teams, and how to fix them.
              I'm a software engineer certified in Scrum and SAFe, with 7+ years of experience in the software agency industry.
            </p>
          </div>

          {/* Row 3 - Certification Badge Bar */}
          <div className="flex flex-wrap justify-center gap-4">
            {certifications.map((cert, index) => (
              <a
                key={index}
                href={cert.url}
                target="_blank"
                rel="noopener noreferrer"
                className="transform hover:scale-105 transition duration-300 grayscale hover:grayscale-0"
                aria-label={cert.alt}
              >
                <img
                  loading="lazy"
                  decoding="async"
                  src={cert.src}
                  alt={cert.alt}
                  className="h-16 w-auto"
                />
              </a>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default SummarySection;